export default __webpack_public_path__ + "static/media/body-footer-icon.ecbf1cb5.svg";